import { BTFileSystem, type IBTFileSystemData } from "legacyComponents/FileUploadContainer.types";

export interface IFolder {
    id: number;
    title: string;
}

export class BrowseBTFilesListResponse {
    // MediaListResponse
    constructor(data: any) {
        this.files = data.files.map((file: IBTFileSystemData) => new BTFileSystem(file));
    }

    files: BTFileSystem[];
}
